import React from 'react';
import { Icon } from './Icon.js';
export const IconPhoneCharging3 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M5 2L5 22L19 22L19 2L5 2Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M11.1182 13H16.1182L13.1182 19H10.8818L12.8818 15H7.88184L10.8818 9H13.1182L11.1182 13Z", fill: "currentColor", "data-stroke": "none" }),
        React.createElement("path", { d: "M11 6L13 6", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconPhoneCharging3.js.map